import { SearchFieldPropertiesType } from "@website/ui/search-field/search-field.types";
import { useCallback, useRef } from "react";

export const useSearchField = (properties: SearchFieldPropertiesType) => {
  const {
    autoFocus,
    "aria-label": ariaLabel,
    disabled,
    onChange,
    placeholder,
    value,
    onFocus,
    onBlur,
    onSubmit,
    onStartIconClick,
    onEndIconClick,
    onKeyDown,
    defaultValue
  } = properties;
  const inputReference = useRef<HTMLInputElement>(null);

  const onRootClick = useCallback(() => {
    inputReference.current?.focus();
  }, []);

  return {
    rootProps: {
      onClick: onRootClick
    },
    inputProps: {
      autoFocus,
      "aria-label": ariaLabel,
      ref: inputReference,
      disabled,
      onChange,
      placeholder,
      value,
      onFocus,
      onBlur,
      onKeyDown,
      defaultValue
    },
    submitButtonProps: {
      tabIndex: -1, // remove tab focus
      onClick: onSubmit,
      disabled
    },
    startIconProperties: {
      onClick: onStartIconClick
    },
    endIconProperties: {
      onClick: onEndIconClick
    }
  };
};
